import {createRouter, createWebHistory} from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  {
    path: '/catalogue',
    name: 'catalogue',
    component: () => import(/* webpackChunkName: "catalogue" */ '../views/Catalogue.vue')
  },
  {
    path: '/commissions',
    name: 'commissions',
    component: () => import(/* webpackChunkName: "commissions" */ '../views/Commissions.vue')
  },
  {
    path: '/commissions/:slug',
    name: 'commission',
    props: true,
    component: () => import(/* webpackChunkName: "commission" */ '../views/Commission.vue')
  },
  {
    path: '/listening',
    name: 'listenings',
    component: () => import(/* webpackChunkName: "listenings" */ '../views/Listenings.vue')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue')
  },
  {
    path: '/colophon',
    name: 'colophon',
    component: () => import(/* webpackChunkName: "colophon" */ '../views/Colophon.vue')
  },

  {
    path: '/journal',
    name: 'journal',
    component: () => import(/* webpackChunkName: "journal" */ '../views/Journal.vue')
  },

  {
    path: '/journal-tag/:slug',
    name: 'journal-tag',
    component: () => import(/* webpackChunkName: "journal" */ '../views/Journal.vue')
  },

  {
    path: '/journal/:slug',
    name: 'journal-page',
    props: true,
    component: () => import(/* webpackChunkName: "journal-page" */ '../views/JournalPage.vue')
  },
  {
    path: '/product/:slug',
    name: 'product',
    props: true,
    component: () => import(/* webpackChunkName: "product" */ '../views/Product.vue')
  },

  {
    path: '/preview-page',
    name: 'page',
    props: true,
    component: () => import(/* webpackChunkName: "page" */ '../views/Page.vue')
  },
  {
    path: '/product-category/:slug',
    name: 'product-category',
    props: true,
    component: () => import(/* webpackChunkName: "catalogue" */ '../views/Catalogue.vue')
  },
  {
    path: '/:slug',
    name: 'page',
    props: true,
    component: () => import(/* webpackChunkName: "page" */ '../views/Page.vue')
  },
  {
    path: '/:catchAll(.*)',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue')
  },
]

let base_url = '/';
// if (process.env.NODE_ENV === 'production') base_url = '/habi-sabi/';
  
const router = createRouter({
  history: createWebHistory(base_url),
  routes
});

export default router;
